module.exports = __webpack_public_path__ + "img/feral.bb8f301f.jpg";